import React from 'react';

const Logo = () => {
    return (
        <div className='logo_wrapper'>
                <a href={process.env.REACT_APP_SITE_URL} className="b-brand">
                    <img style={{maxWidth: '170px'}} src={'/logo.png'} alt={'GOODEGG Token'}/>
                </a>
        </div>
    );
};

export default Logo;